import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

interface CytestLinkProps {
  className?: string
  children?: React.ReactNode
  showAsLink?: boolean
}

const CytestLink: React.FC<CytestLinkProps> = ({ 
  className = '', 
  children = 'Cyfuture',
  showAsLink = true 
}) => {
  const navigate = useNavigate()
  const location = useLocation()

  // Check if we're on a test page
  const isOnTestPage = location.pathname.includes('/test/') && 
                      !location.pathname.includes('/instructions') &&
                      !location.pathname.includes('/system-check') &&
                      !location.pathname.includes('/completed') &&
                      !location.pathname.includes('/history')

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    
    if (isOnTestPage) {
      // Don't allow navigation away from test pages
      console.log('Navigation blocked - user is on test page')
      return
    }
    
    // Navigate to dashboard
    navigate('/dashboard')
  }

  // If on test page, render as plain text
  if (isOnTestPage) {
    return (
      <span className={className}>
        {children}
      </span>
    )
  }

  // If showAsLink is false, render as plain text
  if (!showAsLink) {
    return (
      <span className={className}>
        {children}
      </span>
    )
  }

  // Render as clickable link
  return (
    <button
      onClick={handleClick}
      className={`${className} hover:text-blue-600 transition-colors duration-200 cursor-pointer`}
      title="Go to Dashboard"
    >
      {children}
    </button>
  )
}

export default CytestLink
